import React from 'react';
import PropTypes from 'prop-types';

import Snackbar, { SnackbarsWrapper } from '../../components/Snackbars';
import { snackbarPropType } from '../../types/snackbar';

const DEFAULT_SNACKBAR_VERTICAL_POSITION = 'bottom';
const DEFAULT_SNACKBAR_HORIZONTAL_POSITION = 'left';

const groupSnackbarsByPosition = snackbars => snackbars.reduce((groups, snackbar) => {
    const { snackbarProps: { anchorOrigin = {} } } = snackbar;

    const verticalPosition = anchorOrigin.vertical || DEFAULT_SNACKBAR_VERTICAL_POSITION;
    const horizontalPosition = anchorOrigin.horizontal || DEFAULT_SNACKBAR_HORIZONTAL_POSITION;
    const currentSnackbars = groups?.position || [];

    return {
        ...groups,
        [verticalPosition]: {
            ...groups[verticalPosition],
            [horizontalPosition]: [...currentSnackbars, snackbar],
        },
    };
}, { top: { }, bottom: { } });

const SnackbarContainer = ({ snackbars = [], hideSnackbar = () => {} }) => {
    const snackbarsGroups = groupSnackbarsByPosition(snackbars);

    return Object.keys(snackbarsGroups).map(verticalPosition =>
        Object.keys(snackbarsGroups[verticalPosition]).map((horizontalPosition) => {
            const snackbarGroup = snackbarsGroups[verticalPosition][horizontalPosition];
            return (
                <SnackbarsWrapper
                    key={ `snackbargroup-${verticalPosition}- ${horizontalPosition}` }
                    position={{ vertical: verticalPosition, horizontal: horizontalPosition }}
                >
                    {snackbarGroup.map(({ id, snackbarProps }) => (
                        <Snackbar
                            key={ id }
                            snackbarProps={ snackbarProps }
                            onClose={ () => hideSnackbar(id) }
                        />
                    ))}
                </SnackbarsWrapper>
            );
        }));
};

SnackbarContainer.propTypes = {
    snackbars: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        snackbarProps: PropTypes.shape(snackbarPropType),
    })),
    hideSnackbar: PropTypes.func,
};

export default SnackbarContainer;
